import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/GitHub-Mark-120px-plus.png'


const _hoisted_1 = { class: "Player" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", { href: "https://github.com/pn11/unintentional-podcast-player" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    height: "20"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "Unintentional Podcast Player", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = ["type", "src"]
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = ["href"]
const _hoisted_10 = ["width", "src"]
const _hoisted_11 = ["href"]
const _hoisted_12 = ["width", "src"]
const _hoisted_13 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.getRandomEpisode && _ctx.getRandomEpisode(...args)))
    }, "Another episode"),
    _hoisted_4,
    _hoisted_5,
    _createElementVNode("audio", {
      controls: "",
      preload: "auto",
      width: "100%",
      type: _ctx.audio_type,
      src: _ctx.audio_url
    }, [
      _createElementVNode("a", { href: _ctx.audio_url }, _toDisplayString(_ctx.audio_url), 9, _hoisted_7)
    ], 8, _hoisted_6),
    _hoisted_8,
    _createElementVNode("h2", null, [
      _createElementVNode("a", { href: _ctx.show_link }, _toDisplayString(_ctx.show_title), 9, _hoisted_9)
    ]),
    _createElementVNode("img", {
      width: _ctx.imgWidth,
      src: _ctx.show_cover_url
    }, null, 8, _hoisted_10),
    _createElementVNode("h3", null, [
      _createElementVNode("a", { href: _ctx.episode_link }, _toDisplayString(_ctx.episode_title), 9, _hoisted_11)
    ]),
    _createElementVNode("img", {
      width: _ctx.imgWidth,
      src: _ctx.episode_art_url
    }, null, 8, _hoisted_12),
    _createElementVNode("p", { innerHTML: _ctx.episode_description_html }, null, 8, _hoisted_13)
  ]))
}